export default __webpack_public_path__ + "static/media/paroparo.0dc66365.png";